import React from 'react';
import { DraggableCore, DraggableCoreProps } from 'react-draggable';
import { Props as RndProps, Rnd } from 'react-rnd';
import * as S from '@styles/chat/chat.style';
import {
  CHAT_POPUP_CLASSNAME,
  chatRoomRemWidth,
  POPUP_DRAG_CANCEL_CLASSNAME,
  POPUP_DRAG_HANDLE_CLASSNAME,
  RESIZABLE_CHAT_ELEMENT_CLASSNAME,
} from 'constants/chat';
import _ from 'lodash';

const ChatPopupWrapper = ({
  draggableCoreProps,
  popupRef,
  defaultPosition,
  rndProps,
  children,
}: {
  draggableCoreProps: Partial<DraggableCoreProps>;
  popupRef: React.RefObject<HTMLDivElement>;
  defaultPosition: { x: string; y: string };
  rndProps: RndProps;
  children: React.ReactNode;
}) => {
  const popupRndPropsDefaultValues = {
    resizeHandleStyles: {
      right: { cursor: 'ew-resize' },
      bottom: { cursor: 'ns-resize' },
      bottomRight: { cursor: 'nwse-resize' },
    },
    className: `z-[99] w-fit !flex flex-col bg-my-gray-100 rounded-xl overflow-hidden border border-solid border-my-gray-70 !transform-none ${RESIZABLE_CHAT_ELEMENT_CLASSNAME}`,
    style: {
      boxShadow: '0px 8px 24px 0px rgba(23, 32, 42, 0.16)',
    },
    minWidth: chatRoomRemWidth * 16,
    maxWidth: typeof window !== 'undefined' ? window.innerWidth / 2 : 0,
    minHeight:
      typeof window !== 'undefined' ? (window.innerHeight / 100) * 60 : 0,
    maxHeight: typeof window !== 'undefined' ? window.innerHeight : 0,
    disableDragging: true,
    default: {
      x: null,
      y: null,
      height: chatRoomRemWidth * 16,
      width: null,
    },
  };
  return (
    <DraggableCore
      {...draggableCoreProps}
      cancel={POPUP_DRAG_CANCEL_CLASSNAME}
      handle={POPUP_DRAG_HANDLE_CLASSNAME}
    >
      <S.ChatPopup
        className={CHAT_POPUP_CLASSNAME}
        ref={popupRef}
        top={!_.isNil(defaultPosition.y) ? defaultPosition.y : null}
        left={!_.isNil(defaultPosition.x) ? defaultPosition.x : null}
      >
        <Rnd {...popupRndPropsDefaultValues} {...rndProps}>
          {children}
        </Rnd>
      </S.ChatPopup>
    </DraggableCore>
  );
};

export default ChatPopupWrapper;
